// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    new-cap,
    no-cond-assign,
    no-restricted-globals,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import reactUpdate from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {assert} from 'Asserts';
import {Sequence} from 'biojs/Sequence';
import * as Util from 'biojs/Util';
import {
  CRISPRSequence,
  CRISPRVector,
  FileInputStateShape,
  ValueLink,
  VectorSourceType,
  VECTOR_SOURCE_TYPE,
} from 'constants/CRISPRConstants';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Side} from 'constants/MolbioConstants';
import * as NavConstants from 'constants/NavConstants';
import {SequenceSummary, SequenceServerResponse} from 'constants/SequenceConstants';
import * as SequenceDAO from 'dao/SequenceDAO';
import FolderSelector from 'file-browser/FolderSelector';
import FileStates from 'FileStates';
import SequenceImportInput from 'import-sequence/SequenceImportInput';
import {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import * as sequtil from 'molbio/SeqUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import LegacySelect2, {LegacySelect2ChangeEvent} from 'ui-library/LegacySelect2';
import APIUtil from 'util/APIUtil';
// @ts-expect-error
import BenchlingData from 'util/drag-and-drop/BenchlingData';
import DropTarget from 'util/drag-and-drop/DropTarget';
import {Optional, InputChangeEvent} from 'util/Types';

import CRISPRAssemblyActions from './CRISPRAssemblyActions';

const {formatBaseCount} = Util;
const {SEQUENCE_TYPE} = FileBrowserConstants;

export interface ExistingSequenceInputStateShape {
  sequence?: CRISPRSequence | null;
}

function sequencePreviewLink({name, length, circular, id}: CRISPRSequence, addgeneId?: number): JSX.Element {
  const topology = circular ? 'circular' : 'linear';
  const sequenceInfoComponent = (
    <span>
      <a
        onClick={function () {
          return FileStates.get().openFolderItem(id, {open: true, source: 'crispr-assembly'});
        }}
      >
        <BenchlingIcon icon="upload" />
      </a>{' '}
      <span className="faded">{`${formatBaseCount(length)} \u00B7 ${topology}`}</span>
    </span>
  );
  return (
    <small className="u-tiny-spacing-top">
      {addgeneId != null ? (
        <Row>
          <Col sm={6}>{sequenceInfoComponent}</Col>
          <Col sm={6} className="text-right">
            <span className="faded">Addgene: </span>
            <a href={`https://www.addgene.org/${addgeneId}/`} target="_blank" rel="noopener noreferrer">
              {addgeneId}
            </a>
          </Col>
        </Row>
      ) : (
        sequenceInfoComponent
      )}
    </small>
  );
}

interface VectorSelectorProps {
  assemblyCid: string;
  vectorSelectorState: {vector?: CRISPRVector};
  vectorLoading: boolean;
  vectors: Array<CRISPRVector>;
}

class VectorSelector extends React.Component<VectorSelectorProps> {
  vectorOptions = (): Array<{id: string; text: string}> =>
    _.chain(this.props.vectors)
      .sortBy((vector) => vector.insertionRegionEnd)
      .sortBy((vector) => vector.insertionRegionStart)
      .sortBy((vector) => vector.sequence.name)
      .map((vector) => {
        const extra = _.compact([vector.fullName, vector.addgeneId]);
        return {
          id: vector.id,
          text: `${vector.sequence.name}${extra.length ? ` (${extra.join(', ')})` : ''}`,
        };
      })
      .value();

  vectorChangeHandler = (e: LegacySelect2ChangeEvent): void =>
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    CRISPRAssemblyActions.selectVector(this.props.assemblyCid, e.val);

  render(): JSX.Element {
    return (
      <div>
        <LegacySelect2
          placeholder={this.props.vectorLoading ? 'Loading vectors...' : 'Choose vector'}
          options={this.vectorOptions()}
          // otherwise undefined and Select2 is uncontrolled
          value={
            (this.props.vectorSelectorState.vector != null
              ? this.props.vectorSelectorState.vector.id
              : undefined) != null
              ? this.props.vectorSelectorState.vector != null
                ? this.props.vectorSelectorState.vector.id
                : undefined
              : null
          }
          onChange={this.vectorChangeHandler}
          disabled={this.props.vectorLoading}
        />
        {this.props.vectorSelectorState.vector != null
          ? sequencePreviewLink(
              this.props.vectorSelectorState.vector.sequence,
              this.props.vectorSelectorState.vector.addgeneId
            )
          : undefined}
      </div>
    );
  }
}

interface FileInputProps {
  assemblyCid: string;
  fileInputState: FileInputStateShape;
}

class FileInput extends React.Component<FileInputProps> {
  _getImportErrorLink = (unusedArg?: never): ValueLink<string | null> => ({
    value: this.props.fileInputState.importError,
    requestChange: (newValue: string | null): void => {
      CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
        fileInputState: reactUpdate(this.props.fileInputState, _.object([['importError', {$set: newValue}]])),
      });
    },
  });

  _handleChangeSequenceName = (e: InputChangeEvent): void => {
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      fileInputState: reactUpdate(
        this.props.fileInputState,
        _.object([['sequenceName', {$set: e.target.value}]])
      ),
    });
  };

  _handleChangeFolder = (e: {target: {value: string}}): void => {
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      fileInputState: reactUpdate(
        this.props.fileInputState,
        _.object([['folderId', {$set: e.target.value}]])
      ),
    });
  };

  render(): JSX.Element {
    return (
      <div>
        {this.props.fileInputState.sequence != null ? (
          <div>
            <FormGroup>
              <Label>Sequence Name</Label>
              <input
                type="text"
                value={this.props.fileInputState.sequenceName}
                onChange={this._handleChangeSequenceName}
              />
              {sequencePreviewLink(this.props.fileInputState.sequence)}
            </FormGroup>
            <FormGroup>
              <Label>Folder</Label>
              <FolderSelector
                showInventory={true}
                value={this.props.fileInputState.folderId}
                onChange={this._handleChangeFolder}
                unsetOnFetchFail={true}
              />
            </FormGroup>
            <hr key="hr" />
          </div>
        ) : undefined}
        <FormGroup>
          <SequenceImportInput
            importErrorLink={this._getImportErrorLink()}
            multi={false}
            updateSequences={(...args) => {
              // @ts-expect-error: possible bug? Logic expects this to be a single sequence but appears to be an array
              const sequence: SequenceSummary = args[0];
              CRISPRAssemblyActions.selectSequence(this.props.assemblyCid, sequence);
            }}
          />
        </FormGroup>
      </div>
    );
  }
}

interface ExistingSequenceInputProps {
  assemblyCid: string;
  existingSequenceInputState: ExistingSequenceInputStateShape;
}

class ExistingSequenceInput extends React.Component<ExistingSequenceInputProps> {
  static TYPE_ERROR_MESSAGE = 'Only a sequence can be selected as a vector.';

  onDrop = (e: unknown): void => {
    const bd = BenchlingData(e);
    const files = bd.getData(BenchlingData.FILES_MIME_TYPE) || [];
    // eslint-disable-next-line no-restricted-syntax
    const fileIds = _.pluck(files, 'id');
    if (!fileIds.length) {
      return;
    }
    if (fileIds.length > 1) {
      notifications.error('Only one file can be selected as a vector.');
      return;
    }
    const [fileId] = Array.from(fileIds);
    if (APIUtil.apiIdToType(fileId) !== ModelTypeConstants.SEQUENCE) {
      notifications.error(ExistingSequenceInput.TYPE_ERROR_MESSAGE);
      return;
    }
    SequenceDAO.get(fileId)
      .done((sequence: SequenceServerResponse) => {
        if (sequence.sequence_type === SEQUENCE_TYPE.OLIGO) {
          notifications.error(ExistingSequenceInput.TYPE_ERROR_MESSAGE);
          return;
        }
        CRISPRAssemblyActions.selectExistingSequence(this.props.assemblyCid, sequence);
      })
      .fail(notifications.notifyError);
  };

  _handleOpenProjects = (): void => {
    SidepanelActions.openSection(NavConstants.SECTIONS.PROJECTS);
  };

  clear = (): void => {
    CRISPRAssemblyActions.selectExistingSequence(this.props.assemblyCid, null);
  };

  render(): JSX.Element {
    if (this.props.existingSequenceInputState.sequence != null) {
      return (
        <div>
          <p>
            <span className="faded u-danger-pointer pull-right" onClick={this.clear}>
              <BenchlingIcon icon="xmark-large" />
            </span>
            <BenchlingIcon className="faded" icon={FolderItemIcon.Sequence} />{' '}
            {this.props.existingSequenceInputState.sequence.name}
          </p>
          {sequencePreviewLink(this.props.existingSequenceInputState.sequence)}
        </div>
      );
    }
    return (
      <DropTarget
        shouldCaptureDrop={true}
        mimeTypes={[BenchlingData.FILES_MIME_TYPE]}
        dropEffect="link"
        targetDesc="CRISPR assembly"
        onDrop={this.onDrop}
      >
        <div className="drop-help">
          {'Search for a sequence in the '}
          <a onClick={this._handleOpenProjects}>file browser</a>
          {' and drag it here'}
        </div>
      </DropTarget>
    );
  }
}

interface SelectVectorStepProps {
  assemblyCid: string;
  vectors: Array<CRISPRVector>;
  vectorLoading: boolean;
  vectorSelectorState: {vector?: CRISPRVector};
  existingSequenceInputState: ExistingSequenceInputStateShape;
  fileInputState: FileInputStateShape;
  biojsSequence: Sequence | null;
  enzyme: Enzyme | null;
  vectorSourceType: VectorSourceType;
  insertionRegion: {
    start: number;
    end: number;
  };
  finalizingSelectedVector: boolean;
}

class SelectVectorStep extends React.Component<SelectVectorStepProps> {
  selectedSequence = (): Optional<SequenceSummary> => {
    switch (this.props.vectorSourceType) {
      case VECTOR_SOURCE_TYPE.SELECT_VECTOR:
        // @ts-expect-error: typed as CRISPRSequence but needs to have startIndex defined as well
        return this.props.vectorSelectorState.vector != null
          ? this.props.vectorSelectorState.vector.sequence
          : undefined;
      case VECTOR_SOURCE_TYPE.CREATE_FROM_FILE:
        // @ts-expect-error: incompatible types
        return this.props.fileInputState.sequence;
      case VECTOR_SOURCE_TYPE.SELECT_EXISTING_SEQUENCE:
        // @ts-expect-error: typed as CRISPRSequence but needs to have startIndex defined as well
        return this.props.existingSequenceInputState.sequence;
      default:
        return undefined;
    }
  };

  startIndex = (): number => {
    let left;
    return (left = __guard__(this.selectedSequence(), (x: SequenceSummary) => x.startIndex)) != null
      ? left
      : 1;
  };

  sequenceLength = (end: number): number => {
    let left;
    return (left = __guard__(this.selectedSequence(), (x: SequenceSummary) => x.length)) != null
      ? left
      : end + 1;
  };

  renderVectorSourceTypeChoice = (choice: VectorSourceType, text: string): JSX.Element => (
    <div className="radio">
      <label>
        <input
          type="radio"
          value={choice}
          checked={this.props.vectorSourceType === choice}
          onChange={(e) => {
            CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
              vectorSourceType: e.target.value as VectorSourceType,
            });
          }}
        />
        {text}
      </label>
    </div>
  );

  renderInsertionRegionInput = (key: Side, text: string): JSX.Element => {
    let value: Optional<number>;
    if (key === 'start') {
      value = sequtil.modelStartToDisplay(this.props.insertionRegion.start, this.startIndex());
    } else {
      value = sequtil.modelEndToDisplay(
        this.props.insertionRegion.end,
        this.sequenceLength(this.props.insertionRegion.end),
        this.startIndex()
      );
    }
    return (
      <input
        type="number"
        placeholder={text}
        value={value != null ? value : undefined}
        onChange={(e) => {
          let value: number | null = parseInt(e.target.value, 10);

          if (key === 'start') {
            if (isNaN(value)) {
              value = null;
            } else {
              value = sequtil.displayStartToModel(value, this.startIndex());
            }
          } else {
            assert(key === 'end', "expected key to be 'start' or 'end'");
            if (isNaN(value)) {
              value = null;
            } else {
              value = sequtil.displayEndToModel(value, this.sequenceLength(value), this.startIndex());
            }
          }

          CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
            insertionRegion: reactUpdate(this.props.insertionRegion, _.object([[key, {$set: value}]])),
          });
        }}
      />
    );
  };

  render(): JSX.Element {
    return (
      <fieldset>
        <legend>Select Expression Vector</legend>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={4}>
              <Label className="u-input-line-height">Vector Source</Label>
            </Col>
            <Col sm={8} lg={6}>
              {this.renderVectorSourceTypeChoice(
                VECTOR_SOURCE_TYPE.SELECT_VECTOR,
                'Select one of the bookmarked plasmids'
              )}
              {this.renderVectorSourceTypeChoice(
                VECTOR_SOURCE_TYPE.SELECT_EXISTING_SEQUENCE,
                'Choose a plasmid from your Benchling folders'
              )}
              {this.renderVectorSourceTypeChoice(VECTOR_SOURCE_TYPE.CREATE_FROM_FILE, 'Upload a new plasmid')}
              {(() => {
                switch (this.props.vectorSourceType) {
                  case VECTOR_SOURCE_TYPE.SELECT_VECTOR:
                    return (
                      <VectorSelector
                        assemblyCid={this.props.assemblyCid}
                        vectorSelectorState={this.props.vectorSelectorState}
                        vectorLoading={this.props.vectorLoading}
                        vectors={this.props.vectors}
                      />
                    );
                  case VECTOR_SOURCE_TYPE.CREATE_FROM_FILE:
                    return (
                      <FileInput
                        assemblyCid={this.props.assemblyCid}
                        fileInputState={this.props.fileInputState}
                      />
                    );
                  case VECTOR_SOURCE_TYPE.SELECT_EXISTING_SEQUENCE:
                    return (
                      <ExistingSequenceInput
                        assemblyCid={this.props.assemblyCid}
                        existingSequenceInputState={this.props.existingSequenceInputState}
                      />
                    );
                  default:
                    return null;
                }
              })()}
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={4}>
              <Label>Assembly Method</Label>
            </Col>
            <Col sm={8}>Type IIS Cloning</Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={4}>
              <Label className="u-input-line-height">Insertion Region</Label>
            </Col>
            <Col sm={4} lg={3}>
              {this.renderInsertionRegionInput('start', 'Start')}
            </Col>
            <Col sm={4} lg={3}>
              {this.renderInsertionRegionInput('end', 'End')}
            </Col>
          </Row>
          <Row>
            <Col sm={4}>{null}</Col>
            <Col sm={8} lg={6}>
              <p className="help-block">
                {this.selectedSequence() == null
                  ? 'Select a vector.'
                  : this.props.biojsSequence == null
                    ? 'Loading...'
                    : this.props.enzyme == null
                      ? 'Distinct type IIS enzyme cutsites were not found at the specified start and end.'
                      : `Assembly will generate primers that can be annealed and ligated \
          into the plasmid after digestion with ${this.props.enzyme.get('name')}.`}
              </p>
            </Col>
          </Row>
        </FormGroup>
        <Button
          buttonStyle={ButtonStyle.PRIMARY}
          size={ButtonSize.SMALL}
          className="pull-right"
          disabled={this.props.finalizingSelectedVector || this.props.enzyme == null}
          text={this.props.vectorLoading ? 'Loading...' : 'Next'}
          onClick={(e) => {
            let metadata;
            e.preventDefault();
            CRISPRAssemblyActions.finalizeSelectedVector(this.props.assemblyCid);
            const {vector} = this.props.vectorSelectorState;
            if (this.props.vectorSourceType === VECTOR_SOURCE_TYPE.SELECT_VECTOR && vector != null) {
              metadata = {addgeneId: vector.addgeneId, name: vector.sequence.name};
            } else {
              metadata = null;
            }
            analytics.track('crispr', 'selected_assembly_vector', metadata);
          }}
        />
      </fieldset>
    );
  }
}

export default SelectVectorStep;

function __guard__<T, V>(value: Optional<T>, transform: (t: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}
